import "./index.scss";
import Image from "@components/Image";
import { useNavigateLogin } from "@hooks/navigate";
import { useAppDispatch } from "@hooks/redux";
import { LivestreamVideoType } from "@models/common";
import { showVideoDisplay } from "@store/globalVideoSlice";
import { formatImgUrl } from "@utils/format";
import classNames from "classnames";
import { AspectRatio } from "@pages/videoCreating/videoCreatingSlice";

interface VideoCoverProps {
  type?: string;
  className?: string;
  cover?: string;
  videoId?: string;
  videoUrl?: string;
  videoSource?: string;
  aspectRatio?: AspectRatio;
  children?: React.ReactElement;
  hoverEnlarge?: boolean;
  isVideo?: boolean;
  region?: string;
  showRecordIcon?: boolean;
  handleshowLiveRecord?: () => void;
  kalo_pos?: string;
  showAdIcon?: boolean;
  videoIconSize?: "size64" | "size60" | "size48" | "size30";
  onClick?: () => void;
  bordered?: boolean;
  videoType?: VIDEO_TYPE;
  adIconSize?: string;
  showBreakdownIcon?: boolean;
}

export interface QueryLiveDetailRes {
  id: string;
  record_type: LivestreamVideoType;
  fullUrl: string;
  shortUrl: string;
  screenshotUrl: string;
  record_start_time: string;
  record_duration: string;
  complement_ranges: { startTime: number; endTime: number }[];
  is_purchase: boolean;
}

const VideoCover = ({
  className,
  cover,
  videoId,
  videoUrl,
  videoSource,
  aspectRatio,
  children,
  hoverEnlarge = false,
  isVideo = true,
  region,
  kalo_pos,
  showAdIcon,
  videoIconSize,
  adIconSize,
  onClick,
  bordered,
  videoType = "video_btn",
  showBreakdownIcon,
}: VideoCoverProps) => {
  const { isLogin } = useNavigateLogin();
  const dispatch = useAppDispatch();

  return (
    <Image
      type="video"
      videoType={videoType}
      region={region}
      videoId={videoId}
      videoIcon={isVideo}
      videoIconSize={videoIconSize}
      adIconSize={adIconSize}
      bordered={bordered}
      className={classNames("Layout-VideoCover", className)}
      url={cover ? cover : videoId ? formatImgUrl("video", videoId) : ""}
      onClick={async (event) => {
        onClick && onClick();
        if (isVideo && (videoId || videoUrl)) {
          event.stopPropagation();
          if (!isLogin) {
            return;
          }
          dispatch(
            showVideoDisplay({
              type: videoType,
              region,
              videoId,
              videoURL: videoUrl,
              videoSource,
              aspectRatio,
              kalo_pos,
            }),
          );
          return;
        }
      }}
      hoverEnlarge={hoverEnlarge}
      showAdIcon={showAdIcon}
      showBreakdownIcon={showBreakdownIcon}
    >
      {children}
    </Image>
  );
};

export default VideoCover;
